import React from "react";
import { IS_ANDROID, IS_STANDALONE } from "@/config";
// import AppStoreLink from "_c/native-app-link/AppStore";
import PlayMarketLink from "_c/native-app-link/PlayMarket";
import PT from "prop-types";

const AppLinks = ({ t }) => {
  if (IS_STANDALONE) return null;
  return (
    <div>
      {IS_ANDROID && <PlayMarketLink t={t} />}
      {/*IS_IOS && <AppStoreLink t={t} />*/}
    </div>
  );
};
AppLinks.propTypes = {
  t: PT.func.isRequired,
};
export default AppLinks;
